import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { fetchAccessPoint } from 'store/actions/accessPoints/fetchAccessPoints';
import { fetchProduct } from 'store/actions/products/fetchProducts';
import { updateAccesPoint } from 'store/actions/accessPoints/updateAccessPoint';
import AccessPointEditForm from './AccessPointEditForm';
import Breadcrumbs, { generateBreadcrumbsFromPath } from 'components/layout/Layout/Breadcrumbs';
import Column from 'components/ui/show/Column';
import fetchResourceById from 'components/hoc/fetchResourceById';
import Header from 'components/ui/general/Header';
import InnerColumn from 'components/ui/show/InnerColumn';
import LoadingCard from 'components/loading/LoadingCard';
import ResourceNotFound from 'pages/NotFound/ResourceNotFound';
import Section from 'components/ui/general/Section';
import Title from 'components/ui/general/Title';
import translate from 'components/hoc/translate';
import utils from 'helpers/utils';

class AccesPointEditContainer extends Component {
    componentDidMount() {
        const { fetchAccessPointProduct, productId } = this.props;

        if (productId) {
            fetchAccessPointProduct(productId);
        }
    }

    handleSubmitForm = (formValues) => {
        const {
            data,
            dispatchForm,
            id,
            history,
            productId,
        } = this.props;

        return new Promise((resolve) => {
            dispatchForm({
                id: id,
                onError: () => {
                    resolve();
                },
                onSuccess: () => {
                    resolve(history.push(`/products/${ productId }/access-points/${ id }/show`));
                },
                values: utils.diffObjects(data, formValues),
            });
        });
    };

    render() {
        const {
            data,
            history,
            id,
            location,
            product,
            resource,
            resourceFetchFailed,
            resourceFetchLoading,
            translate,
        } = this.props;

        if (resourceFetchLoading) {
            return <LoadingCard />;
        }

        if (resourceFetchFailed) {
            return <ResourceNotFound />;
        }

        const breadcrumbs = [];

        if (utils.isEmpty(product)) {
            breadcrumbs.push(
                {
                    label: translate('resources.access_points.title'),
                    link: `/${ resource }`,
                },
                {
                    label: data.title || id,
                    link: `/${ resource }/${ id }/show`,
                },
                {
                    label: translate('actions.edit'),
                }
            );
        } else {
            breadcrumbs.push(
                ...generateBreadcrumbsFromPath({
                    products: translate('resources.products.title'),
                    [product.id]: product,
                    'access-point': translate('resources.access_points.title'),
                    [data.id]: data,
                }, this.props),
            );
        }

        return (
            <div>
                <Breadcrumbs breadcrumbs={ breadcrumbs }/>

                <Header>
                    <Title title={ translate('resources.access_points.actions.edit.title', { title: data.title }) } />
                </Header>

                <Section>
                    <Column>
                        <InnerColumn>
                            <AccessPointEditForm
                                initialValues={ data }
                                form='access-point-edit'
                                handleSubmitForm={ this.handleSubmitForm }
                                history={ history }
                                location={ location }
                            />
                        </InnerColumn>
                    </Column>
                </Section>

            </div>
        );
    }
}

AccesPointEditContainer.propTypes = {
    dispatchForm: PropTypes.func.isRequired,
    data: PropTypes.object,
    fetchAccessPointProduct: PropTypes.func,
    history: PropTypes.object.isRequired,
    id: PropTypes.number.isRequired,
    location: PropTypes.object.isRequired,
    product: PropTypes.object,
    productId: PropTypes.string,
    resource: PropTypes.string.isRequired,
    resourceFetchFailed: PropTypes.bool.isRequired,
    resourceFetchLoading: PropTypes.bool.isRequired,
    translate: PropTypes.func.isRequired,
};

const mapStateToProps = (state, props) => {
    return {
        product: props.productId ? state.products.data[props.productId] : null,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchForm: (payload) => {
            dispatch(updateAccesPoint(payload));
        },
        fetchAccessPointProduct: (id) => {
            dispatch(fetchProduct({
                id: id,
            }));
        },
    };
};

const enhance = compose(
    connect(mapStateToProps, mapDispatchToProps),
    translate,
    fetchResourceById({
        action: fetchAccessPoint,
        resource: 'access-points',
    })
);

export default enhance(AccesPointEditContainer);


// WEBPACK FOOTER //
// ./src/pages/accessPoints/edit/AccessPointEditContainer.js